import { useState, useEffect, useLayoutEffect, useRef, memo } from "react"

import { Main } from "./styles"
import { useWatchVariations, mvSubscribe } from "./../context"
import { STEPS, KILL_ROUTE, LAUNCH_ROUTE } from "./../constants"
import { useDictionary } from "contexts/Dictionary"
import { useFocusManager } from "react-aria"
import camelCase from "utils/camelCase"
import { useScroll } from "framer-motion"

function VarNavButton({ ctx, uid, label }) {
  const pos = STEPS.indexOf(uid)
  const { route, newstepindex, active, fromui, wactive, incard } = useWatchVariations(ctx)
  const rfmain = useRef(null)
  const dictionary = useDictionary()

  function redirect(e) {
    //    if (selected.get() || disabled.get()) return
    fromui.set(true)
    route.set(`/${active.get()}/${uid}`)
  }

  function isSelected(v) {
    return v === pos
  }

  function setTabIndex(state) {
    return state ? 0 : -1
  }

  function onNewstepindex(v) {
    const { current: input } = rfmain
    if (!input) return
    const state = isSelected(v)
    input.checked = state
    input.tabIndex = setTabIndex(state)
  }

  function isDisabled(v) {
    return v && !+v.smap[pos]
  }

  function onWactive(v) {
    const { current: input } = rfmain
    if (!input) return
    input.disabled = isDisabled(v)
  }

  useLayoutEffect(() => mvSubscribe("VarNavButton newstepindex", newstepindex, onNewstepindex, false), [])
  useLayoutEffect(() => mvSubscribe("VarNavButton wactive", wactive, onWactive), [])

  return (
    <div>
      <input ref={rfmain} type='radio' name={`mv-nav`} value={uid} onChange={redirect} aria-labelledby={`mv-nav-${uid}-${incard || ""}`} />
      <span id={`mv-nav-${uid}-${incard || ""}`}>{dictionary[camelCase(`configurator-title-${label}`)]("", "")}</span>
    </div>
  )
}

export function VarNav({ ctx }) {
  const { route, variations, wactive } =
    useWatchVariations(ctx)
  const rfmain = useRef(null)
  const focusManager = useFocusManager()
  /*
    function fixScroll() {
      const R = rfmain.current?.getBoundingClientRect()
      const wrapper = rfmain.current.querySelector("div")
      const el = rfmain.current?.querySelector("input[tabIndex='0']")
      if (!el || !wrapper) return
      const r = el?.parentNode?.getBoundingClientRect()
      if (!r) return
      const offset = el.offsetLeft - (wrapper.offsetWidth - r.width) / 2
      rfmain.current.querySelector("div").scrollLeft = offset
    }
  */
  function onRoute(v) {
    display(!!v && v !== KILL_ROUTE)
    //    setTimeout(fixScroll, 16)
  }

  function onWactive(v) {
    if (!v || !route.get()) return
    display(true)
  }

  function display(v) {
    rfmain.current?.classList[!!v ? "add" : "remove"]("wv_reveal")
  }

  function autoFocus(v) {
    setTimeout(() => {
      focusManager.focusNext({ from: rfmain.current, wrap: true, tabbable: true })
    }, 40)
  }

  useLayoutEffect(() => {
    autoFocus()
  }, [])

  useLayoutEffect(() => mvSubscribe("VarNav route", route, onRoute), [])
  useLayoutEffect(() => mvSubscribe("VarNav wactive", wactive, onWactive, false), [])

  return (
    <Main role='radiogroup' aria-labelledby='wv_nav_title' ref={rfmain}>
      {/*<p id='wv_nav_title'>{dictionary.variationsHeading()}</p>*/}
      <div>
        {variations.map(variation => (
          <VarNavButton key={variation} ctx={ctx} uid={variation} label={variation} />
        ))}
      </div>
    </Main>
  )
}

export function VarNavInCard({ ctx, selected }) {
  const { route, variations, wactive, incard } =
    useWatchVariations(ctx)
  const rfmain = useRef(null)
  const rfscroll = useRef(null)

  const { scrollX } = useScroll({
    container: rfscroll,
    axis: "x",
    offset: ["start end", "end end"],
  })

  function onScroll(x) {
    const offset = 2
    const rtl = process.browser && document.querySelector("html").getAttribute("dir") === "rtl"
    const scrollmax = rfscroll.current.scrollWidth - rfscroll.current.offsetWidth

    if (rtl) {
      rfscroll.current.classList[x >= -offset ? "add" : "remove"]("nextonly")
      rfscroll.current.classList[x <= (-scrollmax + offset) ? "add" : "remove"]("prevonly")
    }
    else {
      rfscroll.current.classList[x <= offset ? "add" : "remove"]("nextonly")
      rfscroll.current.classList[x >= (scrollmax - offset) ? "add" : "remove"]("prevonly")
    }
  }

  useLayoutEffect(() => mvSubscribe("VarNav scroll", scrollX, onScroll), [])

  useLayoutEffect(() => {
    window.addEventListener("resize", onResize, false)
    onResize()

    return () => window.removeEventListener("resize", onResize, false)

    function onResize() {
      onScroll(scrollX.get())
    }
  }, [])

  function onRoute(v) {
    const state = !!v && v !== KILL_ROUTE && v !== LAUNCH_ROUTE
    if (!state) setTimeout(() => {
      if (rfscroll.current) rfscroll.current.scrollLeft = 0
    }, 300)
    display(state)
  }

  function onWactive(v) {
    if (!v || !route.get()) return
    display(true)
  }

  function display(v) {
    rfmain.current?.classList[!!v ? "add" : "remove"]("wv_reveal")
  }

  function autoFocus(v) {
    setTimeout(() => {
      const target = rfmain.current.querySelector("input:not(:disabled)")
      if (!target) return
      target.focus()
    }, 40)
  }

  function onSelection(v) {
    if (v === incard) {
      autoFocus()
    }
  }
  useLayoutEffect(() => mvSubscribe("ModelVariations selected", selected, onSelection, false), [])

  useLayoutEffect(() => mvSubscribe("VarNav route", route, onRoute), [])
  useLayoutEffect(() => mvSubscribe("VarNav wactive", wactive, onWactive, false), [])

  //  useLayoutEffect(() => mvSubscribe("VarNav route", gready, onGready), [])

  return (
    <Main role='radiogroup' aria-labelledby='wv_nav_title' ref={rfmain}>
      {/*<p id='wv_nav_title'>{dictionary.variationsHeading()}</p>*/}
      <div ref={rfscroll}>
        {variations.map(variation => (
          <VarNavButton key={variation} ctx={ctx} uid={variation} label={variation} />
        ))}
      </div>
    </Main>
  )
}
